export const outreachTypes = ['call', 'text', 'canvass', 'ivr', 'text-survey'];
